import {
  Box,
  Button,
  ButtonProps,
  CircularProgress,
  CircularProgressProps,
} from "@mui/material";
import { forwardRef } from "react";

export type HButtonProps = {
  loading?: boolean;
  circularProgressProps?: CircularProgressProps;
  inline?: boolean;
} & ButtonProps;

const HButton = forwardRef<HTMLButtonElement, HButtonProps>(
  (
    { loading = false, inline, circularProgressProps, children, ...rest },
    ref,
  ) => {
    return (
      <Button {...rest} ref={ref}>
        <Box position="relative" display={inline ? "inline" : "initial"}>
          {loading && (
            <Box position="absolute" left={-30}>
              <CircularProgress
                data-testid="circular-progress"
                role="progressbar"
                aria-label="Caricamento in corso..."
                size={20}
                sx={theme => ({
                  color: theme.palette.buttons?.primary?.disabled?.color,
                })}
                {...circularProgressProps}
              />
            </Box>
          )}
          {children}
        </Box>
      </Button>
    );
  },
);

export { HButton };
